export default __webpack_public_path__ + "static/media/list512.351c97c8.png";